import {TextInput} from '@/components/atoms'
import {PageContainer} from '@/components/organisms'

const SalesUomsEdit = ({saleUomsFields, handleSalesUomsInputChange, errors}) => {
  return (
    <PageContainer data-testid="product-edit-brand-content">
      <div className="">
        <div className="">
          <div className="heading mt-[10px] text-base font-semibold">Sale Uoms</div>
          <div>
            {saleUomsFields
              ?.filter(field => !field.languages)
              ?.map((field, index) => (
                <div key={`${index}`}>
                  <div className="mb-3  mt-[29px] pb-5 text-base font-semibold">
                    {'Sales UoMs '}
                    {index + 1}
                  </div>
                  <div className="mt-3 grid grid-cols-4 gap-4 pb-5">
                    <TextInput
                      className="text-sm"
                      isDark={true}
                      label={'Code'}
                      placeholderText={'Code'}
                      disabled={true}
                      value={`${field?.code ?? '-'} (${field?.name ?? '-'})`}
                      error={errors?.[field?.code] || errors?.[field?.name]}
                    />
                    <TextInput
                      className="text-sm"
                      isDark={true}
                      label={'UPC'}
                      type="number"
                      placeholderText={'Add UPC'}
                      value={field.upc}
                      error={errors?.[field.upc]}
                      disabled={true}
                      onChange={value => handleSalesUomsInputChange(index, 'upc', value)}
                    />
                    <TextInput
                      className="text-sm"
                      isDark={true}
                      label={'Base UOM Conversion Numerator'}
                      placeholderText={'Add Base UOM Conversion Numerator'}
                      disabled={true}
                      value={`${field.baseUomConversionNumerator}`}
                      error={errors?.[field.baseUomConversionNumerator]}
                      onChange={value => handleSalesUomsInputChange(index, 'baseUomConversionNumerator', value)}
                    />
                    <TextInput
                      className="text-sm"
                      isDark={true}
                      label={'Base UOM Conversion Denominator'}
                      placeholderText={'Add Base UOM Conversion Denominator'}
                      disabled={true}
                      value={`${field.baseUomConversionDenominator}`}
                      error={errors?.[field.baseUomConversionDenominator]}
                      onChange={value => handleSalesUomsInputChange(index, 'baseUomConversionDenominator', value)}
                    />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </PageContainer>
  )
}

export default SalesUomsEdit
